import {
  IBackgroundCheckSettingsCreateRequest,
  IBackgroundCheckSettingsResponse
} from "@wingspanhq/background-checks/dist/lib/interfaces";
import { WSPanel } from "@wingspanhq/fe-component-library";
import { DefinitionDataSourceType } from "@wingspanhq/payments/dist/interfaces";
import * as Yup from "yup";

import { CreateBackgroundChecksPartialForm } from "../../../../modules/BackgroundChecks/createRequirementDefinition/CreateBackgroundChecksPartialForm";
import { RequirementDefinitionStandardBackgroundCheckFormValues } from "../../../../types";
import { getBaseEditValues } from "../../../../utils/getBaseEditValues";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_BACKGROUND_CHECK_FORM: RequirementDefinitionTemplateForm<
  IBackgroundCheckSettingsResponse,
  RequirementDefinitionStandardBackgroundCheckFormValues,
  IBackgroundCheckSettingsCreateRequest
> = {
  getDefaultSettingsValues: template => ({
    instructions: "",
    package: ""
  }),
  getEditSettingsValues(template, requirementDefinition, settings) {
    return {
      instructions: settings.instructions ?? "",
      package: settings.backgroundCheckPackageId
    };
  },
  mapDataSourceResponseToRequirementCreateRequest(response) {
    return {
      dataSourceId: response.backgroundCheckRequestSettingsId,
      dataSourceType: DefinitionDataSourceType.BackgroundCheckRequestSettings
    };
  },
  mapFormDataToDataSourceCreateRequest(values) {
    return {
      backgroundCheckPackageId: values.package,
      instructions: values.instructions,
      title: values.name
    };
  },
  partialForm: (
    <WSPanel>
      <CreateBackgroundChecksPartialForm />
    </WSPanel>
  ),
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({
    instructions: Yup.string(),
    package: Yup.string().required("Required")
  })
};
